var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"material-icons",staticStyle:{"display":"inline-flex","vertical-align":"middle","align-items":"center","font-size":"inherit !important","margin-top":"-2.5px !important"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }